<template>
  <v-container fluid class="px-5">
    <!-- SNACKBAR -->
    <v-snackbar
      v-model="snack"
      :color="snackColor"
      :timeout="snackTime"
      bottom
      right
    >
      {{ snackText }}
    </v-snackbar>
    <!-- SNACKBAR -->

    <!-- LOADER -->
    <v-dialog v-model="loaderDialog" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          <v-row class="py-2">
            <span> {{ loaderDialogText }} </span>
          </v-row>
          <v-row>
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- LOADER -->

    <!-- CONFIRM -->
    <v-dialog v-model="confirmDialog" max-width="450">
      <v-card class="py-3">
        <v-card-title class="headline"> {{ confirmHeader }} </v-card-title>
        <v-card-text class="subtitle-1">
          {{ confirmText }}
        </v-card-text>
        <v-card-actions class="px-6">
          <v-btn color="primary" outlined @click="limpiar"> Cancelar </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="confirmar"> Aceptar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- CONFIRM -->

    <v-row justify="space-between" align="center">
      <v-col cols="12" md="3">
        <h2 class="px-3">Informe SLA - SISA</h2>
      </v-col>
      <v-col cols="12" md="4">
        <v-form ref="fileForm" lazy-validation>
          <v-row align="center" justify="start">
            <v-col cols="12" md="8" class="p-0 pt-7">
              <v-file-input
                v-model="file"
                label="Inf. LLamadas PBX"
                :rules="fileRules"
                accept=".csv"
                outlined
                dense
              ></v-file-input>
            </v-col>
            <v-col cols="12" md="3" class="pt-0">
              <v-tooltip bottom color="success">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-on="on"
                    v-bind="attrs"
                    color="green"
                    :dark="!file ? false : true"
                    :block="$vuetify.breakpoint.smAndDown"
                    @click="confirmSubir"
                    :disabled="!file"
                  >
                    <v-icon class="ml-2">fas fa-file-upload</v-icon>
                  </v-btn>
                </template>
                <span>Subir Informe</span>
              </v-tooltip>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
        </v-form>
      </v-col>
    </v-row>

    <v-divider></v-divider>
    <v-row align="center" justify="center" class="pt-4 pb-1">
      <v-col class="pt-0 pl-4" cols="12" md="4">
        <v-text-field
          class="text-xs-center"
          v-model="search"
          dense
          append-icon="search"
          label="Búsqueda"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
      <v-spacer></v-spacer>

      <v-col class="pt-0" cols="12" md="2">
        <v-text-field
          v-model="fechaInicio"
          type="date"
          hide-details
          dense
          label="Ajustar Desde"
          :max="new Date().toISOString().substr(0, 10)"
          clearable
        ></v-text-field>
      </v-col>
      <v-col class="pt-0" cols="12" md="2">
        <v-text-field
          v-model="fechaFin"
          type="date"
          dense
          hide-details
          label="Hasta"
          :max="new Date().toISOString().substr(0, 10)"
          clearable
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="1" class="text-right pt-0">
        <v-tooltip bottom color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              color="primary"
              dark
              :block="$vuetify.breakpoint.smAndDown"
              @click="confirmAjuste"
            >
              <v-icon>fas fa-sliders-h</v-icon>
            </v-btn>
          </template>
          <span>Ajustar Tiempos</span>
        </v-tooltip>
      </v-col>
      <v-col class="pt-0" cols="12" md="1">
        <v-tooltip bottom color="success">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              color="green"
              :block="$vuetify.breakpoint.smAndDown"
              dark
              @click="descargarInforme"
            >
              <v-icon>fas fa-file-download</v-icon>
            </v-btn>
          </template>
          <span>Descargar</span>
        </v-tooltip>
      </v-col>
    </v-row>

    <v-divider></v-divider>
    <v-row>
      <v-col cols="12">
        <v-stepper non-linear v-model="step">
          <v-stepper-header>
            <v-stepper-step editable step="1"> Llamadas PBX</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step editable step="2">
              Asistencias Ajustadas</v-stepper-step
            >
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-data-table
                :headers="headersLlamadas"
                :items="llamadasPBX"
                :loading="loaderLlamadasPBX"
                loading-text="Listando Datos..."
                :search="search"
                class="elevation-2"
              >
                <template v-slot:[`item.date`]="{ item }">
                  {{ formatDate(item.date) }}
                </template>
              </v-data-table>
            </v-stepper-content>
          </v-stepper-items>
          <v-stepper-content step="2">
            <v-data-table
              :headers="headers"
              :items="cabinasTemp"
              :loading="loaderCabinasTemp"
              loading-text="Listando Datos..."
              :search="search"
              class="elevation-2"
            ></v-data-table>
          </v-stepper-content>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import moment from "moment";
import XLSX from "xlsx";

export default {
  data() {
    return {
      step: 2,
      snack: false,
      snackColor: "primary",
      snackTime: 4000,
      snackText: "Notification",
      confirmDialog: false,
      confirmHeader: "Subir LLamadas",
      confirmText:
        "Esta accion sobreescribira la informacion actual de las LLamadas, Desea continuar?",
      loaderDialogText: "Leyendo LLamadas, Por Favor Espere...",
      loaderCabinasTemp: false,
      esLLamada: false,
      text: "Historial Gruas",
      file: null,
      fileRules: [
        (v) => !!v || "El archivo no puede estar vacío.",
        (v) => this.isCSV(v) || "El archivo debe ser un CSV.",
      ],
      search: "",
      loaderDialog: false,
      loaderLlamadasPBX: false,
      dialog: false,
      fechaInicio: new Date().toISOString().substr(0, 10),
      fechaFin: new Date().toISOString().substr(0, 10),
      cabinasTemp: [],
      llamadasPBX: [],
      reporteLlamadasPBX: [],
      headers: [
        {
          text: "Numero Asistencia",
          value: "numeroAsistencia",
          width: 150,
          align: "center",
        },
        {
          text: "Placa",
          value: "placa",
          width: 100,
          align: "center",
        },
        {
          text: "Rango Aceptación (minutos)",
          value: "rangoAceptacion",
          width: 120,
          align: "center",
        },
        {
          text: "Rango Asignación (minutos)",
          value: "rangoAsignacion",
          width: 120,
          align: "center",
        },
        {
          text: "Rango Contacto (minutos)",
          value: "rangoContacto",
          width: 120,
          align: "center",
        },
        {
          text: "Tipo Asistencia",
          value: "tipoAsistencia",
          width: 200,
          align: "center",
        },
        {
          text: "Localidad SISA",
          value: "localidadSISA",
          width: 150,
          align: "center",
        },
        {
          text: "Detalle Arribo",
          value: "detalleArribo",
          width: 120,
          align: "center",
        },
      ],
      headersLlamadas: [
        {
          text: "Date",
          value: "date",
          width: 120,
          align: "center",
        },
        {
          text: "Time",
          value: "time",
          width: 120,
          align: "center",
        },
        {
          text: "Source",
          value: "source",
          width: 120,
          align: "center",
        },
        {
          text: "Destination",
          value: "destination",
          width: 120,
          align: "center",
        },
        {
          text: "Duration",
          value: "duration",
          width: 120,
          align: "center",
        },
        {
          text: "Type",
          value: "type",
          width: 120,
          align: "center",
        },
      ],
    };
  },
  created() {
    const today = new Date();
    const firstDayInMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    this.fechaInicio = firstDayInMonth.toISOString().substring(0, 10);

    this.listarCabinasTemp();
    this.listarLlamadasPBX();
    this.getReporteLlamadas();
  },
  computed: {},
  methods: {
    getFechaActual() {
      let today = new Date();
      let fechaGuardado =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
      return fechaGuardado;
    },
    isCSV(file) {
      return file && file.name.endsWith(".csv");
    },
    uploadFile() {
      if (this.$refs.fileForm.validate()) {
        this.confirmDialog = false;
        this.loaderDialog = true;

        const formData = new FormData();
        formData.append("file", this.file);

        let header = { Authorization: "Bearer " + this.$store.state.token };
        let configuracion = { headers: header };

        axios
          .post("api/ReporteSLA/ReadLLamadasCSV", formData, configuracion)
          .then((res) => {
            if (res.status == 200) {
              this.snack = true;
              this.snackColor = "primary";
              this.snackText = "Las LLamadas se guardaron correctamente!";

              this.step = 1;
              this.listarLlamadasPBX();
            }
          })
          .catch((err) => {
            this.snack = true;
            this.snackColor = "error";
            this.snackText =
              "No se pudo leer las columnas, revise el formato del archivo";
          })
          .finally(() => {
            this.loaderDialog = false;
            this.file = null;
            this.$refs.fileForm.resetValidation();
          });
      }
    },
    confirmSubir() {
      this.esLLamada = true;
      this.loaderDialogText = "Leyendo LLamadas, Por Favor Espere...";
      this.confirmHeader = "Subir LLamadas";
      this.confirmText =
        "Esta accion sobreescribira la informacion actual de las LLamadas, Desea continuar?";
      this.confirmDialog = true;
    },
    confirmAjuste() {
      this.esLLamada = false;
      this.confirmHeader = "Ajustar Informacion";
      this.confirmText =
        "Esta accion sobreescribira la informacion del reporte anterior, Desea continuar?";
      this.confirmDialog = true;
    },
    limpiar() {
      this.confirmDialog = false;
    },
    listarCabinasTemp() {
      this.loaderCabinasTemp = true;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get("/Sisa/Encuestas/GetSLAEncuestas", configuracion)
        .then((res) => (this.cabinasTemp = res.data))
        .catch((err) => console.error(err))
        .finally(() => (this.loaderCabinasTemp = false));

      // axios
      //   .get("api/ReporteSLA/Sisa", configuracion)
      //   .then((res) => {
      //     this.cabinasTemp = res.data;
      //   })
      //   .catch((err) => console.error(err))
      //   .finally(() => (this.loaderCabinasTemp = false));
    },
    listarLlamadasPBX() {
      this.loaderLlamadasPBX = true;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get("api/ReporteSLA/LlamadasPBX", configuracion)
        .then((res) => (this.llamadasPBX = res.data))
        .catch((err) => console.error(err))
        .finally(() => (this.loaderLlamadasPBX = false));
    },
    confirmar() {
      if (this.esLLamada) {
        this.uploadFile();
      } else {
        this.ajustarTiempos();
      }
    },
    async ajustarTiempos() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      this.confirmDialog = false;
      this.loaderDialog = true;
      let hasError = false;

      const urls = [
        "api/ReporteSLA/Relleno",
        "api/ReporteSLA/TiempoAceptacion",
        "api/ReporteSLA/AjusteFechas",
        "api/ReporteSLA/TiempoAsignacion",
        "api/ReporteSLA/TiempoContactoAMSS",
        "api/ReporteSLA/TiempoContactoForaneo",
      ];

      this.loaderDialogText = "Esto puede tardar, espere por favor...";
      for (const url of urls) {
        const proceso = url.split("/");
        this.loaderDialogText = `Trabajando en: ${proceso[2]}...`;
        try {
          let body =
            proceso == "AjusteFechas"
              ? {}
              : { inicio: this.fechaInicio, fin: this.fechaFin };

          await axios.post(url, body, configuracion);
        } catch (error) {
          this.snackColor = "error";
          this.snackText = "Sucedio un error, no se pudo ajustar la informción";

          if (error.response.data) {
            this.snackText =
              error.response.data +
              " y Verificar que tenga Proveedor Asignado o Fechas de Contacto y Asignación Cruzadas";
            this.snackTime = 15000;
          }

          this.snack = true;
          this.loaderDialog = false;
          hasError = true;
          break;
        }
      }

      if (!hasError) {
        this.loaderDialog = false;
        this.snackColor = "primary";
        this.snackText = "La información fue ajustada correctamente!";
        this.snack = true;

        this.step = 2;
        this.listarCabinasTemp();
      }
    },
    ExportarExcel(listado) {
      let data = XLSX.utils.json_to_sheet(listado);
      const workbook = XLSX.utils.book_new();

      const filename =
        this.step == 2
          ? `Base SISA ${this.getFechaActual()}`
          : `Base LlamadasPBX ${this.getFechaActual()}`;

      XLSX.utils.book_append_sheet(workbook, data, "BASE");
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
    descargarInforme() {
      if (this.step == 2) {
        this.formatReporte();
      } else if (this.step == 1) {
        this.ExportarExcel(this.reporteLlamadasPBX);
      }
    },
    formatReporte() {
      const formatDate = (date) => {
        if (!date) return "";
        return date.split("T")[0];
      };

      const listado = this.cabinasTemp.map((data) => {
        data.fechaAlta = formatDate(data.fechaAlta);
        data.fechaAsignacion = formatDate(data.fechaAsignacion);
        data.fechaContacto = formatDate(data.fechaContacto);
        data.programado = data.programado ? "SI" : "";

        delete data.proveedorId;
        delete data.id;
        return data;
      });

      this.ExportarExcel(listado);
    },
    getReporteLlamadas() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get("api/ReporteSLA/Llamadas", configuracion)
        .then((res) => (this.reporteLlamadasPBX = res.data))
        .catch((err) => console.error(err.response));
    },
    formatDate(fecha) {
      if (fecha == null) return "- - - -";
      if (!fecha || typeof fecha != "string") {
        throw new Error(
          "El parametro 'fecha' debe ser de tipo String y no puede estar vacio"
        );
      }

      return moment(fecha).format("YYYY-MM-DD");
    },
  },
};
</script>